export default {
  ACCOUNTS_CSV_DOWNLOAD_COLUMNS: [
    'username',
    'token',
    'links.check',
    'assessments.0.location',
    'assessments.0.assessment_group',
    'assessments.0.assessment_date',
    'assessments.0.created_by',
    'assessments.0.created_at',
    'assessments.0.updated_by',
    'assessments.0.updated_at',
    'created_by',
    'created_at',
    'updated_by',
    'updated_at'
  ],
  ACCOUNTS_CSV_DOWNLOAD_DEFAULT_COLUMNS: [
    'username',
    'links.check'
  ],
  HIDDEN_LINKS: {
  }
}
